import { throttle } from 'lodash';
import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

const usePageBottom = (element: RefObject<HTMLDivElement>) => {
  const [bottom, setBottom] = useState(false);
  useEffect(() => {
    const handleScroll = throttle(() => {
      if (element?.current) {
        const rect = element.current.getBoundingClientRect() as DOMRect;
        const docElem = document.documentElement as HTMLElement;
        const bottomPixels = Math.max(docElem.clientHeight, window.innerHeight || 0) * 1.5;
        const isBottom = rect.y + rect.height < bottomPixels;
        setBottom(isBottom);
      }
    }, 100);

    handleScroll();
    window.addEventListener('scroll', handleScroll, true);

    return () => window.removeEventListener('scroll', handleScroll);
  });

  return bottom;
};

export default usePageBottom;
